import {Injectable} from '@angular/core';
import {EnumUtils} from '../utils/enum.utils';
import {OfferTextModuleProductTypeEnum} from '../enums/offer-text-module-product-type.enum';
import {MyOfferTextModuleContainerModel} from '../models/my-offer-text-module-container.model';
import {OfferTextModuleTypeEnum} from '../enums/offer-text-module-type.enum';
import {OfferTextModuleModel} from '../models/offer-text-module.model';
import {MyDialogDataModel} from '../models/my-dialog-data.model';

@Injectable({
    providedIn: 'root'
})
export class OfferTextModulesContainersUtilsService {

    private initNewOfferTextModulesContainers(dialogModel: MyDialogDataModel) {
        const hardwareProductType = EnumUtils.getKeyByValue(OfferTextModuleProductTypeEnum, OfferTextModuleProductTypeEnum.HARDWARE);
        dialogModel.offerTextModulesHardwareContainers = [
            MyOfferTextModuleContainerModel.getNewModel({
                productType: hardwareProductType,
                textModuleType: EnumUtils.getKeyByValue(OfferTextModuleTypeEnum, OfferTextModuleTypeEnum.DEALER_EK_OFFER),
                text: this.getDefaultModuleText(OfferTextModuleTypeEnum.DEALER_EK_OFFER)
            } as OfferTextModuleModel, 10),
            MyOfferTextModuleContainerModel.getNewModel({
                productType: hardwareProductType,
                textModuleType: EnumUtils.getKeyByValue(OfferTextModuleTypeEnum, OfferTextModuleTypeEnum.ORDERED_QUANTITY_PROLONGABLE),
                text: this.getDefaultModuleText(OfferTextModuleTypeEnum.ORDERED_QUANTITY_PROLONGABLE)
            } as OfferTextModuleModel, 11),
            MyOfferTextModuleContainerModel.getNewModel({
                productType: hardwareProductType,
                textModuleType: EnumUtils.getKeyByValue(OfferTextModuleTypeEnum, OfferTextModuleTypeEnum.SPECIAL_PRICE),
                text:  this.getDefaultModuleText(OfferTextModuleTypeEnum.SPECIAL_PRICE)
            } as OfferTextModuleModel, 12),
        ];

        const supplyProductType = EnumUtils.getKeyByValue(OfferTextModuleProductTypeEnum, OfferTextModuleProductTypeEnum.SUPPLY);
        dialogModel.offerTextModulesSupplyContainers = [
            MyOfferTextModuleContainerModel.getNewModel({
                productType: supplyProductType,
                textModuleType: EnumUtils.getKeyByValue(OfferTextModuleTypeEnum, OfferTextModuleTypeEnum.DEALER_EK_OFFER),
                text:  this.getDefaultModuleText(OfferTextModuleTypeEnum.DEALER_EK_OFFER)
            } as OfferTextModuleModel, 20),
            MyOfferTextModuleContainerModel.getNewModel({
                productType: supplyProductType,
                textModuleType: EnumUtils.getKeyByValue(OfferTextModuleTypeEnum, OfferTextModuleTypeEnum.ORDERED_QUANTITY_PROLONGABLE),
                text: this.getDefaultModuleText(OfferTextModuleTypeEnum.ORDERED_QUANTITY_PROLONGABLE)
            } as OfferTextModuleModel, 21),
            MyOfferTextModuleContainerModel.getNewModel({
                productType: supplyProductType,
                textModuleType: EnumUtils.getKeyByValue(OfferTextModuleTypeEnum, OfferTextModuleTypeEnum.SPECIAL_PRICE),
                text:  this.getDefaultModuleText(OfferTextModuleTypeEnum.SPECIAL_PRICE)
            } as OfferTextModuleModel, 22),
        ];
    }

    private initDedicatedOfferTextModuleContainerWithUserData(moduleToInitWith: OfferTextModuleModel, modules: MyOfferTextModuleContainerModel[]) {
        const moduleToInit = modules.find(module => module.offerTextModule.textModuleType === moduleToInitWith.textModuleType);
        if (moduleToInit) {
            moduleToInit.offerTextModule.text = moduleToInitWith.text;
            moduleToInit.isChecked = true;
        } else {
            console.error('module container was not found for ', moduleToInitWith);
        }

    }

    public reinitOfferTextModulesContainers(dialogModel: MyDialogDataModel) {

        this.initNewOfferTextModulesContainers(dialogModel);

        const project = dialogModel.project;

        if (project.offerTextModules) {
            project.offerTextModules.filter(module => OfferTextModuleProductTypeEnum[module.productType] === OfferTextModuleProductTypeEnum.HARDWARE && module?.text?.length > 0)
                .forEach(hardwareModule => {
                        this.initDedicatedOfferTextModuleContainerWithUserData(hardwareModule, dialogModel.offerTextModulesHardwareContainers)
                    }
                );
        }

        if (project.offerTextModules) {
            project.offerTextModules.filter(module => OfferTextModuleProductTypeEnum[module.productType] === OfferTextModuleProductTypeEnum.SUPPLY  && module.text?.length > 0)
                .forEach(supplyModule => {
                        this.initDedicatedOfferTextModuleContainerWithUserData(supplyModule, dialogModel.offerTextModulesSupplyContainers)
                    }
                );
        }
        // PPU_log console.log('reinitOfferTextModulesContainers finished', dialogModel);
    }

    public getDefaultModuleText(moduleType: OfferTextModuleTypeEnum): string {
        let result = '';
        switch (moduleType) {
            case OfferTextModuleTypeEnum.DEALER_EK_OFFER:
                result = 'Angebot entspricht Händler-EK. Der Distributions-Projekt-EK errechnet sich daraus abzüglich 2%.';
                break;
            case OfferTextModuleTypeEnum.ORDERED_QUANTITY_PROLONGABLE:
                result = 'Das Angebot ist vorbehaltlich der Einhaltung der angegebenen Abnahmemengen bis 10.08.2020 verlängerbar. ' +
                    'Die Abnahmemengen (mind. ca. 80%) verstehen sich gemäß monatlicher Schätzung ' +
                    'auf Basis des Gesamtvolumens oder gemäß vereinbartem Roll-Out-Plan.';
                break;
            case OfferTextModuleTypeEnum.SPECIAL_PRICE:
                result = 'Aufgrund der Sonderpreise ist kein Skonto, Bonus, WKZ möglich. Es muss bitte zum Projektpreis über Kontrakt bestellt werden.';
                break;
        }

        return  result;
    }

    public collectProjectOfferTextContainersDataForRest(dialogModel: MyDialogDataModel) {
        // console.log('dialogModel.offerTextModulesHardwareContainers', dialogModel.offerTextModulesHardwareContainers);
        dialogModel.project.offerTextModules = [];
        dialogModel.offerTextModulesHardwareContainers.forEach(offerTextModulesHardwareContainer =>{
            if( offerTextModulesHardwareContainer.isChecked ) {
                dialogModel.project.offerTextModules.push(offerTextModulesHardwareContainer.offerTextModule);
            }
        });
        dialogModel.offerTextModulesSupplyContainers.forEach(offerTextModulesHardwareContainer =>{
            if( offerTextModulesHardwareContainer.isChecked ) {
                dialogModel.project.offerTextModules.push(offerTextModulesHardwareContainer.offerTextModule);
            }
        });
    }
}
